import _from from './from';
import type { Types } from './types';

export class Map {
  static from = _from;
}

export { Types };